import React from 'react';
import Icon from '../../../components/AppIcon';

const ImpactMetrics = ({ metrics }) => {
  return (
    <section className="py-12 lg:py-16 bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Our Impact in Numbers
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Real-time data showing the difference we're making together
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {metrics?.overview?.map((metric, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-6 shadow-md border border-border text-center"
            >
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center mx-auto mb-4">
                <Icon name={metric?.icon} size={28} color="white" />
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-primary mb-2">
                {metric?.value}
              </div>
              <div className="text-sm text-muted-foreground">{metric?.label}</div>
              {metric?.trend && (
                <div className="flex items-center justify-center gap-1 mt-2 text-xs text-success">
                  <Icon name="TrendingUp" size={14} />
                  <span>{metric?.trend}</span>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="bg-card rounded-xl p-6 shadow-md border border-border">
            <h3 className="text-xl font-semibold text-foreground mb-6 flex items-center gap-2">
              <Icon name="Target" size={24} color="var(--color-primary)" />
              Program Outcomes
            </h3>
            <div className="space-y-4">
              {metrics?.programs?.map((program, index) => (
                <div key={index} className="space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-foreground">{program?.name}</span>
                    <span className="text-sm font-semibold text-primary">{program?.completion}%</span>
                  </div>
                  <div className="w-full bg-muted rounded-full h-3">
                    <div
                      className="bg-gradient-to-r from-primary to-secondary h-3 rounded-full transition-all duration-500"
                      style={{ width: `${program?.completion}%` }}
                    />
                  </div>
                  <div className="flex items-center justify-between text-xs text-muted-foreground">
                    <span>{program?.participants} participants</span>
                    <span>{program?.impact}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-card rounded-xl p-6 shadow-md border border-border">
            <h3 className="text-xl font-semibold text-foreground mb-6 flex items-center gap-2">
              <Icon name="Users" size={24} color="var(--color-secondary)" />
              Volunteer Engagement
            </h3>
            <div className="space-y-6">
              {metrics?.engagement?.map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={item?.icon} size={24} color="var(--color-secondary)" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-sm font-medium text-foreground">{item?.label}</span>
                      <span className="text-lg font-bold text-secondary">{item?.value}</span>
                    </div>
                    <p className="text-xs text-muted-foreground">{item?.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 bg-gradient-to-r from-primary to-secondary rounded-xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-2">Join Our Growing Community</h3>
          <p className="text-white/90 mb-4">
            Be part of the change. Every volunteer hour creates lasting impact.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle" size={20} />
              <span>Verified Impact</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Shield" size={20} />
              <span>Safe Environment</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Award" size={20} />
              <span>Recognition Program</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactMetrics;